import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

function authHeaders() {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token no encontrado");
  return { Authorization: `Bearer ${token}` };
}

export const listSkillAgentCaratulas = async (params = {}) => {
  const response = await axios.get(`${API_URL}/api/skill-agent-caratulas`, {
    headers: authHeaders(),
    params,
  });
  return response.data;
};

export const getSkillAgentCaratulaById = async (id) => {
  const response = await axios.get(
    `${API_URL}/api/skill-agent-caratulas/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const createSkillAgentCaratula = async (payload) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-caratulas`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const updateSkillAgentCaratula = async (id, payload) => {
  const response = await axios.patch(
    `${API_URL}/api/skill-agent-caratulas/${id}`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

export const deleteSkillAgentCaratula = async (id) => {
  const response = await axios.delete(
    `${API_URL}/api/skill-agent-caratulas/${id}`,
    { headers: authHeaders() },
  );
  return response.data;
};

export const duplicateSkillAgentCaratula = async (id) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-caratulas/${id}/duplicate`,
    {},
    { headers: authHeaders() },
  );
  return response.data;
};

export const resolveSkillAgentCaratulaForCreate = async (payload = {}) => {
  const response = await axios.post(
    `${API_URL}/api/skill-agent-caratulas/resolve-for-create`,
    payload,
    { headers: authHeaders() },
  );
  return response.data;
};

/**
 * Adapter boardApi para SkillAgentMoodboardDetail en modo plantilla.
 * Mapea carátula → forma moodboard (Titulo = Name).
 */
function parsePagesJsonField(raw) {
  if (raw == null) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && Array.isArray(parsed.pages)) return parsed.pages;
      return [];
    } catch {
      return [];
    }
  }
  if (raw && Array.isArray(raw.pages)) return raw.pages;
  return [];
}

function mapCaratulaRow(row) {
  if (!row) return row;
  return {
    ...row,
    PagesJson: parsePagesJsonField(row.PagesJson),
    Titulo: row.Name,
    // No usar LineLabel como CategoryLabel: el chrome Stage lo pintaría en la barra.
    CategoryLabel: "",
    StudioLine: "",
    Kind: "caratula",
    Status: "draft",
  };
}

export function buildCaratulaBoardApi() {
  return {
    getById: async (id) => mapCaratulaRow(await getSkillAgentCaratulaById(id)),
    update: async (id, patch) => {
      const mapped = { ...patch };
      if (patch.Titulo != null) {
        mapped.Name = patch.Titulo;
        delete mapped.Titulo;
      }
      if (patch.CategoryLabel != null && mapped.LineLabel == null) {
        mapped.LineLabel = patch.CategoryLabel;
      }
      return mapCaratulaRow(await updateSkillAgentCaratula(id, mapped));
    },
    savePages: async (id, payload, _opts) => {
      return mapCaratulaRow(
        await updateSkillAgentCaratula(id, {
          PagesJson: payload?.PagesJson ?? payload?.pages ?? payload,
          ...(payload?.ChromeStyleJson != null
            ? { ChromeStyleJson: payload.ChromeStyleJson }
            : null),
          ...(payload?.Titulo != null ? { Name: payload.Titulo } : null),
          ...(payload?.CategoryLabel != null
            ? { LineLabel: payload.CategoryLabel }
            : null),
          ...(payload?.StudioLine != null
            ? { StudioLine: payload.StudioLine }
            : null),
        }),
      );
    },
    getPool: async () => ({ searches: [], items: [] }),
  };
}
